import { authService } from '@/services';
import router from '../router/router';
import jwtDecode from 'jwt-decode';
import * as act from '@/store/auth.actions';
import { actions as _act } from '@/models/store.actions';
import store from '@/store/store';
import { EventBus } from '@/helpers/event-bus';
import { permissionsHelper } from '@/helpers/permissions.helper';
import { RoleType } from '@/models/enums';

const state = {
  isLogined: false,
  username: '',
  avatar: '',
  refreshtoken: '',
  refreshtokenexpiressec: 0,
  accesstoken: '',
  accesstokenexpiressec: 0,
  expirerefreshdate: null,
  expireaccessdate: null,
  loginDate: null,
  actions: [],
  lastlogin: '',
  saveLogin: false,
  email: '',
  organization: '',
  sessionId: '',
  organizationId: 0,
  userModules: [],
  orgModules: [],
  userCode: '',
  roleTypeId: RoleType.None
};

const actions = {
  async [act.ACT_REFRESHTOKEM]({ state, commit }) {
    return authService.refreshtokem(state.refreshtoken)
      .then(response => {
        commit(act.MUT_LOGIN, { response, isLogin: false });
        EventBus.$emit('token-refreshed');
        return response;
      });
  },
  async [act.ACT_CHANGEPASS]({ dispatch, commit }, { oldpassword, password, passwordconfirm }) {
    await authService.changepass(oldpassword, password, passwordconfirm);
  },
  [act.ACT_LOGIN](
    { dispatch, commit },
    { username, password, token, recaptchaType, pushNotificationToken, fingerPrint }) {
    return authService
      .login(username, password, token, recaptchaType, pushNotificationToken, fingerPrint)
      .then(response => {
        return onSuccessLogin({ dispatch, commit, response });
      });
  },
  [act.ACT_LOGINGOOGLE](
    { dispatch, commit },
    { code, token, recaptchaType, pushNotificationToken, fingerPrint }) {
    return authService
      .loginGoogle(code, token, recaptchaType, pushNotificationToken, fingerPrint)
      .then(response => {
        if (!response.data.token || !response.data.token['access_token']) {
          var d = JSON.parse(response.data);
          if (d['email']) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({ type: 'needRegister', regdata: d });
          }
        } else {
          return onSuccessLogin({ dispatch, commit, response });
        }
      });
  },
  [act.ACT_LOGINROUMING]({ dispatch, commit }, { id, code, token, recaptchaType, fingerPrint }) {
    return authService
      .loginRouming(id, code, token, recaptchaType, fingerPrint)
      .then(response => {
        if (!response.data.token || !response.data.token['access_token']) {
          var d = JSON.parse(response.data);
          if (d['email']) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({ type: 'needRegister', regdata: d });
          }
        } else {
          return onSuccessLogin({ dispatch, commit, response });
        }
      });
  },
  [act.ACT_LOGINFACEBOOK](
    { dispatch, commit },
    { accessToken, signedRequest, userID, token, recaptchaType, pushNotificationToken, fingerPrint }) {
    return authService
      .loginFacebook(accessToken, signedRequest, userID, token, recaptchaType, pushNotificationToken, fingerPrint)
      .then(response => {
        if (!response.data.token || !response.data.token['access_token']) {
          var d = JSON.parse(response.data);
          if (d['email']) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({ type: 'needRegister', regdata: d });
          }
        } else {
          return onSuccessLogin({ dispatch, commit, response });
        }
      });
  },
  [act.ACT_LOGINMICROSOFT](
    { dispatch, commit },
    { accessToken, token, recaptchaType, pushNotificationToken, fingerPrint }) {
    return authService
      .loginMicrosoft(accessToken, token, recaptchaType, pushNotificationToken, fingerPrint)
      .then(response => {
        if (!response.data.token || !response.data.token['access_token']) {
          var d = JSON.parse(response.data);
          if (d['email']) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({ type: 'needRegister', regdata: d });
          }
        } else {
          return onSuccessLogin({ dispatch, commit, response });
        }
      });
  },
  [act.ACT_LOGINAPPLE](
    { dispatch, commit },
    { authorizationCode, appleUserUid, appleUser, token, recaptchaType, pushNotificationToken, fingerPrint }) {
    return authService
      .loginApple(authorizationCode, appleUserUid, appleUser, token, recaptchaType, pushNotificationToken, fingerPrint)
      .then(response => {
        if (!response.data.token || !response.data.token['access_token']) {
          var d = JSON.parse(response.data);
          if (d['email']) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({ type: 'needRegister', regdata: d });
          }
        } else {
          return onSuccessLogin({ dispatch, commit, response });
        }
      });
  },
  [act.ACT_LOGINECP](
    { dispatch, commit },
    { sign, token, recaptchaType, pushNotificationToken, fingerPrint }) {
    return authService
      .loginEcp(sign, token, recaptchaType, pushNotificationToken, fingerPrint)
      .then(response => {
        if (!response.data.token || !response.data.token['access_token']) {
          var d = JSON.parse(response.data);
          if (d['email']) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({ type: 'needRegister', regdata: d });
          }
        } else {
          return onSuccessLogin({ dispatch, commit, response });
        }
      });
  },
  async [act.ACT_LOGOUT]({ dispatch, commit }) {
    await authService
      .logout()
      .then(() => { })
      .catch(_error => { });
    commit(act.MUT_LOGOUT);
    EventBus.$emit('user-logged-out');
    router.push('/login');
  },
  async [act.ACT_SAVELOGIN]({ commit }, saveLogin) {
    commit(act.MUT_SAVELOGIN, saveLogin);
  },
  async [act.ACT_SAVEAVATAR]({ commit }, avatar) {
    commit(act.MUT_AVATAR, avatar);
  }
};

const mutations = {
  [act.MUT_LOGIN](
    state: any, { response, isLogin }
  ): void {
    let token = response.data.token;
    state.accesstoken = token.access_token;
    state.accesstokenexpiressec = token.access_token_expires_in_sec;
    state.refreshtoken = token.refresh_token;
    state.refreshtokenexpiressec = token.refresh_token_expires_in_sec;
    var curDaterefr = new Date();
    var curDateacces = new Date();
    state.expireaccessdate = curDateacces.setSeconds(curDateacces.getSeconds() + token.access_token_expires_in_sec);
    state.expirerefreshdate = curDaterefr.setSeconds(curDaterefr.getSeconds() + token.refresh_token_expires_in_sec);
    let decodedToken = jwtDecode(token.access_token) as any;
    if (isLogin) {
      state.loginDate = Date();
      state.isLogined = true;
      if (state.saveLogin === true) {
        state.lastlogin = decodedToken.email;
      } else {
        state.lastlogin = '';
      }
      store.commit(_act.ORG_MUT_DETAILSCLEAR);
    }
    state.actions = JSON.parse(decodedToken.useractions);
    state.email = decodedToken.email;
    state.organization = decodedToken.organization;
    state.username = decodedToken.given_name;
    state.sessionId = decodedToken.jti;
    state.organizationId = decodedToken.organizationId || 0;
    state.userModules = (decodedToken.user_modules ? JSON.parse(decodedToken.user_modules) : null) || [];
    state.orgModules = (decodedToken.org_modules ? JSON.parse(decodedToken.org_modules) : null) || [];
    state.userCode = decodedToken.user_code;
    state.roleTypeId = +decodedToken.roleTypeId;
  },
  [act.MUT_LOGOUT](state: any): void {
    state.isLogined = false;
    state.username = '';
    state.avatar = '';
    state.refreshtoken = '';
    state.refreshtokenexpiressec = 0;
    state.accesstoken = '';
    state.accesstokenexpiressec = 0;
    state.expirerefreshdate = null;
    state.expireaccessdate = null;
    state.loginDate = null;
    state.actions = [];
    state.email = '';
    state.organization = '';
    state.sessionId = '';
    state.organizationId = 0;
    state.userModules = [];
    state.orgModules = [];
    state.userCode = '';
    state.roleTypeId = RoleType.None;
    store.commit(_act.ORG_MUT_DETAILSCLEAR);
  },
  [act.MUT_SAVELOGIN](state: any, saveLogin: boolean): void {
    state.saveLogin = saveLogin;
  },
  [act.MUT_AVATAR](state: any, avatar: string): void {
    state.avatar = avatar;
  },
  [act.MUT_USERNAME](state: any, username: string): void {
    state.username = username;
  }
};

const getters = {
  [act.GET_LASTLOGINGET]: state => {
    return state.lastlogin;
  },
  [act.GET_ISLOGINEDGET]: state => {
    return state.isLogined;
  },
  [act.GET_LOGINUSERGET]: state => {
    return state.username;
  },
  [act.GET_AVATAR]: state => {
    return state.avatar;
  },
  [act.GET_EMAILUSERGET]: state => {
    return state.email;
  },
  [act.GET_TOKENSGET]: state => {
    return {
      access: state.accesstoken,
      refresh: state.refreshtoken,
      expirerefreshdate: state.expirerefreshdate,
      expireaccessdate: state.expireaccessdate
    };
  },
  [act.GET_ACCESTOKENGET]: state => {
    return state.accesstoken;
  },
  [act.GET_ACTIONSGET]: state => {
    return state.actions;
  },
  [act.GET_SAVELOGIN]: state => {
    return state.saveLogin;
  },
  [act.GET_ORGGET]: state => {
    return state.organization;
  },
  [act.GET_SESSIONID]: state => {
    return state.sessionId;
  },
  [act.GET_ORGID]: state => {
    return state.organizationId;
  },
  [act.GET_USERMODULES]: state => {
    return state.userModules;
  },
  [act.GET_ORGMODULES]: state => {
    return state.orgModules;
  },
  [act.GET_USERCODE]: state => {
    return state.userCode;
  },
  [act.GET_USERROLE]: state => state.roleTypeId
};

function onSuccessLogin({ dispatch, commit, response }) {
  commit(act.MUT_LOGIN, { response, isLogin: true });
  const promises: Array<any> = [];

  if (permissionsHelper.isAllowedToViewDocuments) promises.push(dispatch(_act.DOC_ACT_LOADCOUNTERS, null, { root: true }));

  promises.push(dispatch(_act.DOC_ACT_LOADBALANCE, null, { root: true }));

  if (permissionsHelper.isAllowedToViewFolders) promises.push(dispatch(_act.FOLD_ACT_LOADFOLDERS, null, { root: true }));

  promises.push(dispatch(_act.USETT_ACT_USERSETTINGS, null, { root: true }));

  return Promise.all(promises).then(() => response.data.warnings);
}

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
